import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";

const Anexo = ({ anexo, label }) => {
    const isPdf = anexo?.toLowerCase().endsWith(".pdf");
    const hasFile = !!anexo;

    return (
        <div className="d-flex flex-column justify-content-center align-items-center">
            {hasFile ? (
                isPdf ? (
                    <>
                        <a
                            href={anexo}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-100"
                        >
                            <div className="ratio ratio-1x1">
                                <div className="bg-danger w-100 px-3 rounded d-flex align-items-center justify-content-center">
                                    <FontAwesomeIcon icon={faFilePdf} color="#ffffff" size="3x" />
                                </div>
                            </div>
                        </a>
                        {label && (
                            <span
                                className="bg-secondary text-white p-1 mt-2 rounded-3"
                                style={{ fontSize: "8pt" }}
                            >
                                {label}
                            </span>
                        )}
                    </>
                ) : (
                    <>
                        <a href={anexo} target="_blank" rel="noopener noreferrer">
                            <img
                                className="rounded"
                                src={anexo}
                                alt={label || "Imagem da infração"}
                                width={120}
                                height={180}
                            />
                        </a>
                        {label && (
                            <span
                                className="bg-secondary text-white p-1 mt-2 rounded-3"
                                style={{ fontSize: "8pt" }}
                            >
                                {label}
                            </span>
                        )}
                    </>
                )
            ) : (
                <div className="ratio ratio-1x1">
                    <div className="bg-danger w-100 px-3 rounded d-flex align-items-center justify-content-center">
                        <FontAwesomeIcon icon={faFilePdf} color="#ffffff" size="3x" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Anexo;
